<template>
  <div class="modal fade" :id="id">
    <div class="modal-dialog modal-lg">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ edit ? $t('mail.signature_modification') : $t('mail.signature_creation') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <Input
              :name="`${id}-signature_name`"
              type="text"
              :label="$t('mail.signature_name')"
              labelClass="form-label fs-6 text-black"
              :inputClass="'form-control form-control-lg form-control-solid'"
              :isRequired="true"
              size="lg"
              :placeholder="$t('mail.signature_name')"
              v-model="formDataSignature.name"
            />
            <div class="row mb-10">
              <div class="col-12">
                 <CKEditor
                    id="mail-signature"
                    :content="formDataSignature.content"
                    @text="getContent"
                    :parent-id="'#'+id"
                />
              </div>
            </div>
            <div class="me-5">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="formDataSignature.enabled" id="flexCheckDefault"/>
                <label class="ms-2 form-label fs-6 text-black" for="flexCheckDefault">
                  {{ $t('mail.signature_default') }}
                </label>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <Button btn-class="btn-sm me-3" type="cancel" id="submit_btn" btn-text="button.cancel" size="7px 30px" @click="closeModal"></Button>
            <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingSignature"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
  import {ref} from "vue";
  import Input from "@/components/Input.vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button.vue"
  import RequiredText from "@/components/RequiredText.vue";
  import CKEditor from '@/components/CKEditor.vue';
  
  const emits = defineEmits(['load'])

  const props = defineProps({
      id: {
        type: String,
        required: true
      },
      parent: {
        type: String,
        required: false
      },
      form: {
        type: Object,
        default: {
          id: '',
          name: '',
          content: '',
          enabled: false
        }
      },
      edit: {
        type: Boolean,
        default: false
      }
  })

  const store = useStore()

  const formDataSignature = ref(props.form)
  const isLoadingSignature = ref(false)

  async function submitForm(){
    let action = props.edit ? 'mails/updateSignature' : 'mails/storeSignature';
    let message = props.edit ? 'notification.signature_updated_successfully' : 'notification.signature_created_successfully';
    try {
      isLoadingSignature.value = true;
      await store.dispatch(action, formDataSignature.value).then((res) =>{
        emits('load');
        formDataSignature.value.id = ''
        formDataSignature.value.name = ''
        formDataSignature.value.content = ''
        formDataSignature.value.enabled = false
        closeModal();
        window.toastr['success'](i18n.global.t(message))
      }) 
    } catch (error) {
    } finally {
      isLoadingSignature.value = false;
    }
  }

  function getContent(text) {
    if (formDataSignature.value.content !== text) formDataSignature.value.content = text
  }

  function closeModal(){
    if(props.parent){
        $('#'+props.parent).modal('toggle')
    }
    $('#'+props.id).modal('toggle')
  }
</script>
    
<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }
</style>